import { IntlFormatters } from 'react-intl';

const getPointsLabel = (points: number, formatMessage: IntlFormatters['formatMessage']) =>
  formatMessage({ id: 'plkPointsEarned' }, { points });

export default getPointsLabel;
